/* ==========================================================================
   Cart preview image — U&S Clothing
   assets/cart-preview-image.js

   Shopify takes a line item's image from the variant and offers no way to
   override it, so a customised item shows the plain product photo in the
   cart — the shopper sees none of the design they just spent five steps on.

   The wizard draws the garment and the artwork onto a canvas at add-to-cart
   time, uploads it, and stores the URL on the line as _preview_image. This
   swaps that in wherever the cart is shown.

   Scope worth being clear about: the cart page and the cart drawer are the
   theme's, so they can be changed. Checkout, order confirmation and the
   admin are Shopify's and still show the variant image. The URL is on the
   order either way, so the print team can always see the design.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__cwCartPreview) return;
  window.__cwCartPreview = true;

  var applied = new WeakSet();

  /* Line items in key order, so a row's index matches the cart. */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function swap(img, url) {
    if (!img || !url || applied.has(img)) return;
    applied.add(img);

    /* Only replace once the new image has actually loaded, so a broken URL
       leaves the product photo in place rather than an empty box. */
    var probe = new Image();
    probe.onload = function () {
      img.srcset = '';
      img.sizes = '';
      img.removeAttribute('data-srcset');
      img.src = url;
      img.classList.add('cw-cart-preview');
    };
    probe.onerror = function () { applied.delete(img); };
    probe.src = url;
  }

  /* Match a rendered row to its line item.

     The cart markup gives each row an id of CartItem-<index>, one-based, in
     the same order as cart.items. Falling back to the variant id covers the
     drawer, which numbers its rows differently. */
  function rowsFor(items) {
    var out = [];

    items.forEach(function (item, i) {
      var url = item.properties && item.properties._preview_image;
      if (!url) return;

      var row = document.getElementById('CartItem-' + (i + 1))
             || document.querySelector('[id$="-' + (i + 1) + '"].cart-item')
             || document.querySelector('.cart-item[data-variant-id="' + item.variant_id + '"]');

      if (!row) {
        /* drawer and notification markup — find by the product link */
        var link = document.querySelector('a[href*="variant=' + item.variant_id + '"]');
        row = link && link.closest('.cart-item, .cart-drawer-item, tr, li');
      }
      if (row) out.push({ row: row, url: url });
    });

    return out;
  }

  function apply() {
    if (!document.querySelector('.cart-item, .cart-drawer-item, cart-drawer')) return;

    fetchCart().then(function (cart) {
      if (!cart || !cart.items) return;
      if (!cart.items.some(function (i) {
        return i.properties && i.properties._preview_image;
      })) return;

      rowsFor(cart.items).forEach(function (hit) {
        var img = hit.row.querySelector('img');
        swap(img, hit.url);
      });
    });
  }

  function boot() {
    apply();

    /* The cart re-renders on quantity change and when the drawer opens. */
    var host = document.querySelector('cart-items, cart-drawer, #main-cart-items') || document.body;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; apply(); }, 250);
    }).observe(host, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.header__icon--cart, cart-drawer')) {
        setTimeout(apply, 500);
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();